module.exports = __webpack_public_path__ + "media/images/arrow-w@2x-06b229550f4da74683813e31a2f93f9b.png";